<section>
  <div class="marine-insurance-description-warning">
    <div class="marine-insurance-description-warning-icon">
      <img src="assets/icons/icon_attention_orange_sm.svg" />
    </div>
    <div class="marine-insurance-description-warning-text">
      <p class="marine-insurance-description-warning-text-header">{{ "LABELS.NOTE" | translate }}!</p>
      <p class="marine-insurance-description-warning-text-content">{{ "RECALCULATION_IS_NEEDED_HINT" | translate }}!</p>
    </div>
  </div>

  <div class="marine-insurance-description-data">
    <div class="row mb-2">
      <div class="col-5 col-md-6 marine-insurance-description-data-label">
        {{ "COMMODITIES_CATEGORY" | translate }}
      </div>
      <div class="col-7 col-md-6 marine-insurance-description-data-value">
        {{ marineInsurance?.insuredValue?.commodity?.name }}
      </div>
    </div>

    <div class="row mb-2" *ngIf="isVehiclesCommodity && !!manufactureDate">
      <div class="col-5 col-md-6 marine-insurance-description-data-label">
        {{ "LABELS.MANUFACTURE_YEAR" | translate }}
      </div>
      <div class="col-7 col-md-6 marine-insurance-description-data-value">
        {{ manufactureDate | customDateByUtc : "YYYY" }}
      </div>
    </div>

    <div class="row mb-2">
      <div class="col-5 col-md-6 marine-insurance-description-data-label">
        {{ "INSURED_VALUE" | translate }}
      </div>
      <div class="col-7 col-md-6 marine-insurance-description-data-value">
        {{ marineInsurance?.insuredValue?.insuredAmount | currency : DEFAULT_CURRENCY_CODE : "symbol" : "1.2-2" }}
      </div>
    </div>
  </div>

  <div class="marine-insurance-description-textarea">
    <app-control-wrapper [control]="formGroup.get('goodsTypeDescription')" [isShowHelper]="false">
      <label for="goodsTypeDescription" control-label>{{ "MARINE_INSURANCE_DESCRIPTION_LABEL" | translate }}</label>
      <textarea
        class="form-control"
        id="goodsTypeDescription"
        name="goodsTypeDescription"
        rows="2"
        control-wrapper
        [formControl]="formGroup.get('goodsTypeDescription')"
        [dropSpecialCharacters]="false"
        [patterns]="CUSTOM_MASK"
        [mask]="'F*'"
        [appMaskErrorTooltip]="'MASK_ERROR.ONLY_ENGLISH_DIGITS_AND_SPECIAL'"
        [placeholder]="'MARINE_INSURANCE_DESCRIPTION_HINT' | translate"
      ></textarea>
    </app-control-wrapper>
  </div>

  <date-picker
    *ngIf="isVehiclesCommodity"
    id="manufactureDate"
    labelClass="mt-2"
    placeholder="LABELS.MANUFACTURE_YEAR"
    minMode="year"
    [maxDate]="maxManufaturerDate"
    dateInputFormat="YYYY"
    name="manufactureDate"
    label="MARINE_INSURANCE_MANUFACTURE_LABEL"
    [showHelper]="false"
    [fc]="formGroup.get('manufactureDate')"
    [errors]="errors.manufactureDate"
  ></date-picker>
</section>

<section class="marine-insurance-description-footer">
  <button type="submit" class="btn btn-primary" [disabled]="isSaving || formGroup.invalid" (click)="onSave()">
    {{ "BUTTON.SAVE" | translate }}
  </button>
</section>

<loading-spinner [show]="isSaving"></loading-spinner>
